import styled from 'styled-components';

const SelectOuter = styled.div`
  position: relative;
  margin-top: 30px;
`;

export default SelectOuter;
